
function prepareFrame() {
  const customMatch = /healthyvoyager.com|localhost/
  var ifrm = document.createElement("iframe");
  const request_url_site = window.location.host
  // console.log(request_url_site)
  let url = 'https://isonic.ai/api';
  let display = 'block'
  let params = ""
  let boxOpen = false
  if (request_url_site.match(/localhost/)) {
    url = 'http://localhost:3000'
  }
  if (request_url_site.match(/localhost:3001|isonic.ai/)) {
    params = ''
    if (window.location.href.match(/mongo/)) {
      params = 'mongo=true';
    }
    if (window.location.pathname.split("/")[1] == 'kristinabeautyinmotion') {
      boxOpen = true;
    }
  }

  const HEALTHY_VOYAGER_BREAKPOINT = 1120;
  const screenMedia = window.matchMedia(`(max-width: 800px)`);


  // const api_key = document.getElementById("letschatwidget").attributes['src'].value.split("?key=")[1]
  if (boxOpen) {
    ifrm.setAttribute("src", url + "/chatbot?startconv=true&requesturl=" + request_url_site + "&" + params);
    ifrm.setAttribute("id", "letschatWidget")
    ifrm.setAttribute("target", "_parent")
    ifrm.style.height = "calc(100% - 48px)";
    ifrm.style.width = "390px";
    ifrm.style.border = "none";
    ifrm.style.display = display;
    ifrm.style.position = "fixed";
    ifrm.style.top = "auto";
    ifrm.style.left = "auto";
    ifrm.style.bottom = "24px";
    ifrm.style.right = "24px";
    ifrm.style.visibility = "visible";
    ifrm.style.zIndex = "2147483647";
    ifrm.style.maxHeight = screenMedia.matches ? "100%" : "784px";
    ifrm.style.boxShadow = "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px, rgba(0, 0, 0, 0.19) 0px 6px 20px 0px";
    ifrm.style.background = "none transparent";
    ifrm.style.opacity = "1";
    ifrm.style.pointerEvents = "auto";
    ifrm.style.touchAction = "auto";
    ifrm.style.borderRadius = screenMedia.matches ? "0" : "16px";
    ifrm.style.setProperty("--widget-border-radius", screenMedia.matches ? "0" : "16px");
    parentdiv = document.getElementById("letschat-container")
    if (parentdiv != null) {
      document.getElementById("letschat-container").appendChild(ifrm);
    }
  } else if (request_url_site.match(customMatch)) {
    const lgScreenMedia = window.matchMedia(`(max-width: ${HEALTHY_VOYAGER_BREAKPOINT}px)`);
    const smScreenMedia = window.matchMedia(`(max-width:800px)`);
    let widget_url = url + "/chatbot?requesturl=" + request_url_site + params
    if (localStorage.getItem('isonichidebydefault') == null) {
      localStorage.setItem('isonichidebydefault', 'true');
    } else if (localStorage.getItem('isonichidebydefault') == 'true') {
      widget_url = widget_url + "&hide_by_default=true"
    } else {
      widget_url = widget_url + "&hide_by_default=false"
      localStorage.setItem('isonichidebydefault', 'false');

    }
    if (localStorage.getItem('isonicftu') == 'yes') {
      localStorage.setItem('isonicftu', 'yes');
      widget_url = widget_url + "&ftu=true"
    }

    ifrm.setAttribute("src", widget_url);
    ifrm.setAttribute("id", "isonicWidget")
    ifrm.setAttribute("target", "_parent")
    const applyCustomStyles = () => {
      // ifrm.style.height     = lgScreenMedia.matches ? "100dvh" : smScreenMedia.matches ? "calc(100% - 48px)" : "auto";
      // ifrm.style.width      = lgScreenMedia.matches ? "100%" : smScreenMedia.matches ? "390px" : "auto";
      // ifrm.style.width      = 0;
      ifrm.style.transition = "flex-grow 0.3s ease-in-out";
      ifrm.style.flexGrow = 1;
      ifrm.style.flexBasis = 0;
      ifrm.style.border = "none";
      ifrm.style.display = display;
      ifrm.style.position = lgScreenMedia.matches || smScreenMedia.matches ? "fixed" : "static";
      ifrm.style.left = "auto";
      ifrm.style.bottom = smScreenMedia.matches ? "0" : lgScreenMedia.matches ? "24px" : "auto";
      ifrm.style.right = smScreenMedia.matches ? "0" : lgScreenMedia.matches ? "24px" : "auto";
      ifrm.style.visibility = "visible";
      ifrm.style.zIndex = "2147483647";
      ifrm.style.maxHeight = lgScreenMedia.matches ? "100%" : "784px";
      ifrm.style.background = "none transparent";
      ifrm.style.opacity = "1";
      ifrm.style.pointerEvents = "auto";
      ifrm.style.touchAction = "auto";
      ifrm.tabIndex = 0;
      ifrm.style.setProperty("--widget-border-radius", lgScreenMedia.matches ? "0" : "16px");
    }

    ifrm.addEventListener('load', () => {
      ifrm.contentWindow.postMessage({ type: 'parentWidth', width: window.innerWidth }, '*');
      ifrm.contentWindow.postMessage({ type: 'hideByDefault', hideByDefault: localStorage.getItem('isonichidebydefault') }, '*');
    });


    /* Get element on Healthy Voyager's site and add iframe */
    parentdiv = document.getElementById("healthyvoyager-isonic")

    const handleChange = () => {
      applyCustomStyles();
      if (ifrm.contentWindow) {
        ifrm.contentWindow.postMessage({ type: 'parentWidth', width: window.innerWidth }, '*');
      }
      if (parentdiv != null) parentdiv.querySelector("#left-column").style.display = lgScreenMedia.matches ? "none" : "block"
    }

    window.matchMedia(`(max-width: ${HEALTHY_VOYAGER_BREAKPOINT}px)`).addEventListener('change', () => {
      handleChange();
    });
    window.matchMedia(`(max-width: 800px)`).addEventListener('change', () => {
      handleChange();
    });

    applyCustomStyles();
    // if(parentdiv!=null){
    retryLoadDiv('#healthyvoyager-isonic')
      .then((div) => {
        div.appendChild(ifrm);
      })
      .catch(error => console.error(error));
    // }
  } else {
    ifrm.setAttribute("src", url + "/chatbot?requesturl=" + request_url_site + params);
    ifrm.setAttribute("id", "isonicWidget")
    ifrm.setAttribute("target", "_parent")
    ifrm.style.height = "80px";
    ifrm.style.width = "80px";
    ifrm.style.border = "none";
    ifrm.style.display = display;
    ifrm.style.position = "fixed";
    ifrm.style.top = "auto";
    ifrm.style.left = "auto";
    ifrm.style.bottom = "24px";
    ifrm.style.right = "24px";
    ifrm.style.visibility = "visible";
    ifrm.style.zIndex = "2147483647";
    ifrm.style.maxHeight = screenMedia.matches ? "100%" : "784px";
    ifrm.style.background = "none transparent";
    ifrm.style.opacity = "1";
    ifrm.style.pointerEvents = "auto";
    ifrm.style.touchAction = "auto";
    ifrm.style.borderRadius = screenMedia.matches ? "0" : "16px";
    ifrm.tabIndex = 0;
    ifrm.style.setProperty("--widget-border-radius", screenMedia.matches ? "0" : "16px");
    parentdiv = document.getElementById("letschat-container")
    if (parentdiv != null) {
      document.getElementById("letschat-container").appendChild(ifrm);
    }

    ifrm.addEventListener('load', () => {
      ifrm.contentWindow.postMessage({ type: 'parentWidth', width: window.innerWidth }, '*');
    });

    const handleChange = () => {
      if (ifrm.contentWindow) {
        ifrm.contentWindow.postMessage({ type: 'parentWidth', width: window.innerWidth }, '*');
      }
    }

    window.matchMedia(`(max-width: 800px)`).addEventListener('change', () => {
      handleChange();
    });
  }

}
// whenever someone calls widget this will be the first thing which will be called--start>>
prepareFrame()
// whenever someone calls widget this will be the first thing which will be called---<<<end

window.addEventListener('message', function (e) {
  const eventName = e.data[0];
  const data = e.data[1];
  const iframe = $("#isonicWidget");
  const screenMedia = window.matchMedia("(max-width: 800px)");
  const site_url = window.location.host
  const customMatch = /healthyvoyager.com|localhost/

  switch (eventName) {
    case 'setHeight':
      if (screenMedia.matches && data != 80) {
        iframe.css('bottom', '0px');
        iframe.css('right', '0px');
        iframe.css('max-height', '100%');
        iframe.css('overflow', 'hidden');
        iframe.height('100dvh');
      } else {
        if (!site_url.match(customMatch)) {
          iframe.css('bottom', '24px');
          iframe.css('right', '24px');
        }
        iframe.css('max-height', '784px');
        iframe.height(data);
      }
      break;
    case 'setWidth':
      if (screenMedia.matches && data != 80) {
        iframe.css('width', '100%');
      } else {
        iframe.width(data);
      }
      break;
    case 'setFlex': {
      iframe.css('flex-grow', data)
    }
    case 'setShadowEffect':
      iframe.css("box-shadow", data);
      break;
    case 'setBorderRadius':
      iframe.css('border-radius', (screenMedia.matches && data != '80px') ? '0px' : data);
      break;
    case 'openWidget':
      iframe.css("display", 'block');
      $('#widgetButton').click();
      startChat();
      break;
    case 'isonichidebydefault':
      localStorage.setItem('isonichidebydefault', e.data[1]);
      break;
    case 'movePin':
      iframe.css(data);
      break;
    case 'startChat':
      if (site_url.match(/explorehoodcanal|localhost/)) {
        startChat(data);
      }
      break;
  }
}, false);


window.addEventListener('touchstart', function (e) {
  e.stopPropagation();
});
window.addEventListener('touchmove', function (e) {
  e.stopPropagation();
});



function startChat(id) {
  $('.startconv').append('<div id="widgetloader"><p>loading...</p></div>');
  $.ajax({
    url: url + "/widget/request_tab",
    type: "get",
    dataType: "script",
    data: { widget_id: id, tab: 'chat', conversation_id: $('#topmenuwidget').attr("data-conversation") },
    success: function (data) {

    },
    error: function () {
      $('#widgetloader').remove();
    }

  })
}


function retryLoadDiv(selector, retries = 4, delay = 1000) {
  return new Promise((resolve, reject) => {
    const attempt = () => {
      const div = document.querySelector(selector);
      if (div) {
        resolve(div);
      } else if (retries > 0) {
        retries--;
        setTimeout(attempt, delay);
      } else {
        reject(new Error(`Failed to load ${selector} after multiple attempts`));
      }
    };
    attempt();
  });
}
